// Taken from https://stackoverflow.com/questions/21409717/chart-js-and-long-labels
export const formatChartLabel = (str: string, maxWidth: number): Array<string> => {
    var sections: Array<string> = [];
    var words = str.split(' ');
    var temp = '';

    words.forEach(function (item, index) {
        if (temp.length > 0) {
            var concat = temp + ' ' + item;

            if (concat.length > maxWidth) {
                sections.push(temp);
                temp = '';
            }
            else {
                if (index === (words.length - 1)) {
                    sections.push(concat);
                    return;
                }
                else {
                    temp = concat;
                    return;
                }
            }
        }

        if (index === (words.length - 1)) {
            sections.push(item);
            return;
        }

        if (item.length < maxWidth) {
            temp = item;
        }
        else {
            sections.push(item);
        }
    });

    return sections;
};